import React, { createContext, useReducer, useMemo } from 'react';
export type CriteriaContextValuesType = {
  criteriaWhenIsSet: boolean;
  criteriaWhoIsSet: boolean;
  criteriaTransportIsSet: boolean;
  defaultValueForCalendar: moment$Moment | null | undefined;
  isJoyview: boolean;
  layerButtonLabel: string;
  layerHeader: string | Node;
  trackingActionName: string;
  setFacetHasSeeMore: (a: boolean) => void;
  displayActivityFilter: boolean;
  displayChildcareFilter: boolean;
  displayDestinationFilter: boolean;
  displaySeasonFilter: boolean;
  displayTypeOfStayFilter: boolean;
  displayFlightDurationFilter: boolean;
};
export const initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: '',
  setFacetHasSeeMore: () => {},
  displayActivityFilter: true,
  displayChildcareFilter: true,
  displayDestinationFilter: true,
  displaySeasonFilter: true,
  displayTypeOfStayFilter: true,
  displayFlightDurationFilter: true,
};
export type CriteriaContextAction = Partial<CriteriaContextValuesType>;

const criteriaContextReducer = (state, action: CriteriaContextAction) => {
  return { ...state, ...action };
};

type CriteriaContextType = [CriteriaContextValuesType, (arg0: CriteriaContextAction) => void];
export const CriteriaContext = createContext<CriteriaContextType>([initialState, () => {}]);
export const CriteriaContextProvider = ({
  children,
  value = {},
}: {
  children: React.ReactNode;
  value?: Partial<CriteriaContextValuesType>;
}) => {
  const [state, dispatch] = useReducer(criteriaContextReducer, { ...initialState, ...value });
  const reducer = useMemo(() => [state, dispatch], [state, dispatch]);
  return <CriteriaContext.Provider value={reducer}>{children}</CriteriaContext.Provider>;
};
